import { useCallback, useEffect, useState } from "react";
import TeamCard from "./TeamCard";
import { postData } from "../../../services/api";

const teamMembers = [
  {
    name: "Yomi Denzel",
    role: "E-Commerce 2.0",
    image:
      "https://www.shutterstock.com/image-photo/close-head-shot-portrait-preppy-600nw-1433809418.jpg",
    description:
      "Yomi is a pioneer in e-commerce and empowers thousands with his strategies.",
  },
  {
    name: "Timothée Moiroux",
    role: "Investissement Immobilier",
    image:
      "https://t4.ftcdn.net/jpg/04/31/64/75/360_F_431647519_usrbQ8Z983hTYe8zgA7t1XVc5fEtqcpa.jpg",
    description: "Timothée started in high school... (your text here)",
  },
  {
    name: "David Sequiera",
    role: "Closing",
    image:
      "https://media.istockphoto.com/id/1154642632/photo/close-up-portrait-of-brunette-woman.jpg?s=612x612&w=0&k=20&c=d8W_C2D-2rXlnkyl8EirpHGf-GpM62gBjpDoNryy98U=",
    description:
      "David specializes in closing deals with high conversion tactics.",
  },
  {
    name: "Manuel Ravier",
    role: "Investissement Immobilier",
    image:
      "https://img.freepik.com/premium-photo/handsome-young-african-man-formalwear-looking-camera-smiling-while-standing-against-grey-wall_425904-1906.jpg",
    description: "Manuel is a real estate investor with international reach.",
  },
];

const TeamSection = () => {
  const [loading, setLoading] = useState(true);
  const [teamData, setTeamData] = useState([]);

  const loadList = useCallback(async () => {
    setLoading(true);
    try {
      const result = await postData("team/list", {});

      if (result.data) {
        setTeamData(result?.data);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadList();
  }, [loadList]);

  //   description: "Coming Soon.";
  //   designation: "VP Client Success";
  //   image: "https://api.successionnow.com/storage/image/team/17495726380804d0fb4bde2f91dabd1a54720.png";
  //   name: "Jeff DeLany";
  return (
    <div className="bg-teal-50 min-h-screen py-12 px-6">
      <div className="flex items-center justify-center">
        <h2 className={"mb-6 "}>
          <span className="block xl:text-5xl text-3xl font-bold text-slate-700">
            {"Leadership"}
          </span>
          <span className="inline-block text-lg uppercase text-slate-400 font-normal tracking-widest border-t-2 border-teal-300 py-1 my-1">
            Succession Now
          </span>
        </h2>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {teamData &&
          Array?.isArray(teamData) &&
          teamData?.length > 0 &&
          teamData?.map((member, index) => (
            <TeamCard key={index} {...member} />
          ))}
      </div>
    </div>
  );
};

export default TeamSection;
